import React from "react";
import { Card, Typography } from "@mui/material";
import dayjs from "dayjs";
import { TooltipProps as RechartsTooltipProps } from "recharts";

interface ChartTooltipProps {
  maxColor: string;
  minColor: string;
  unitLabel: string;
}

const ChartTooltip =
  ({ maxColor, minColor, unitLabel }: ChartTooltipProps) =>
  ({ active, payload, label }: RechartsTooltipProps<number, string>) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload as any;

      return (
        <Card sx={{ p: 1 }}>
          <Typography variant="subtitle2">
            {dayjs(label).format("MMMM DD, YYYY")}
          </Typography>

          <Typography variant="subtitle2">
            Max:{" "}
            <Typography
              component="span"
              fontSize={18}
              fontWeight="bold"
              color={maxColor}
            >
              {`${data.originalMax} ${unitLabel}`}
            </Typography>
          </Typography>

          <Typography variant="subtitle2">
            Min:{" "}
            <Typography
              component="span"
              fontSize={18}
              fontWeight="bold"
              color={minColor}
            >
              {`${data.originalMin}  ${unitLabel}`}
            </Typography>
          </Typography>
        </Card>
      );
    }

    return null;
  };

export default ChartTooltip;
